import outreachMutations from "./mutations/outreach";
import orgMutations from "./mutations/org";

export default {
  ...outreachMutations,
  ...orgMutations,
};
